import { useQueryClient } from '@tanstack/react-query'
import { NumberParam, useQueryParam, withDefault } from 'use-query-params'
import {
  DEBOUNCE_DELAY,
  DEFAULT_PAGE,
  SCROLLABLE_LIST_PAGE_KEY,
} from './constants'

export const useRefreshList = (queryKey: string) => {
  const queryClient = useQueryClient()
  const [pageQuery, setPageQuery] = useQueryParam(
    SCROLLABLE_LIST_PAGE_KEY,
    withDefault(NumberParam, DEFAULT_PAGE),
  )

  const refreshList = async () => {
    if (pageQuery > DEFAULT_PAGE) {
      setPageQuery(DEFAULT_PAGE, 'replaceIn')

      await new Promise<void>((resolve) => {
        const checkQueryState = () => {
          const isFetching = queryClient.isFetching([queryKey])

          if (!isFetching) {
            resolve()
          } else {
            setTimeout(checkQueryState, 100)
          }
        }

        setTimeout(checkQueryState, DEBOUNCE_DELAY + 100)
      })
    } else {
      await queryClient.invalidateQueries({
        queryKey: [queryKey],
      })
    }
  }

  return { refreshList }
}
